var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EA5455",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 19.1834L17.125 13.5609M12.5425 16.5401L22 22.0109L31.4575 16.5401M22 32.9201V22.0001M31.75 26.3334V17.6667C31.7496 17.2868 31.6493 16.9136 31.4592 16.5846C31.269 16.2557 30.9957 15.9825 30.6667 15.7926L23.0833 11.4592C22.754 11.2691 22.3803 11.1689 22 11.1689C21.6197 11.1689 21.246 11.2691 20.9167 11.4592L13.3333 15.7926C13.0043 15.9825 12.731 16.2557 12.5408 16.5846C12.3507 16.9136 12.2504 17.2868 12.25 17.6667V26.3334C12.2504 26.7133 12.3507 27.0865 12.5408 27.4155C12.731 27.7444 13.0043 28.0176 13.3333 28.2076L20.9167 32.5409C21.246 32.7311 21.6197 32.8312 22 32.8312C22.3803 32.8312 22.754 32.7311 23.0833 32.5409L30.6667 28.2076C30.9957 28.0176 31.269 27.7444 31.4592 27.4155C31.6493 27.0865 31.7496 26.7133 31.75 26.3334Z",
    stroke: "#D74E4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageStats);
export default __webpack_public_path__ + "static/media/packageStats.c66cbddcce85327ed4c90f9404c9a39d.svg";
export { ForwardRef as ReactComponent };